/**
 * Common chart data point interface
 * Used across all health chart components (HeartRate, BloodPressure, etc.)
 */
export interface ChartDataPoint {
  /** Short date format for X-axis display (e.g., "20/01") */
  date: string;

  /** Full date format for detailed display (e.g., "20.01.2025") */
  fullDate: string;

  /** Whether this data point is currently selected */
  isSelected?: boolean;

  // Blood Pressure specific properties
  /** Systolic blood pressure reading (mmHg) */
  systolic?: number;

  /** Diastolic blood pressure reading (mmHg) */
  diastolic?: number;

  // Heart Rate specific properties
  /** Heart rate reading (beats per minute) */
  heartRate?: number;

  // Breathing Rate specific properties
  /** Breathing rate reading (breaths per minute) */
  breathingRate?: number;

  // Exercise specific properties
  /** Exercise minutes per week */
  minutesPerWeek?: number;
}
